export enum PermissionsType {
  create = 'create',
  read = 'read',
  update = 'update',
  delete = 'delete',
  /**
   * D-COFFEE-ADMIN: a non-CRUD verb the API models exactly like the four
   * above — `/account/me` sends it as another
   * `resourceScope.execute.isChecked` flag — used for actions that are not a
   * record operation. First (and so far only) holder: `coffee-console`,
   * where it gates flipping the ordering Open/Closed switch. Additive: no
   * existing `PermissionGuard` route asks for it.
   */
  execute = 'execute',
}

export enum RESOURCE_PLATFORM {
  WEB = 'Web',
  APP = 'App',
  DASHBOARD = 'Dashboard',
  SYSTEM = 'System',
}

export const RESOURCE_PLATFORM_OPTIONS = [
  { id: RESOURCE_PLATFORM.WEB, name: 'Web' },
  { id: RESOURCE_PLATFORM.APP, name: 'App' },
  { id: RESOURCE_PLATFORM.DASHBOARD, name: 'Dashboard' },
  { id: RESOURCE_PLATFORM.SYSTEM, name: 'System' },
];

// Maps a platform to its group in the ResourceList returned by /resources/list
export const RESOURCE_PLATFORM_LIST_KEY: Record<
  RESOURCE_PLATFORM,
  'web' | 'app' | 'dashboard' | 'system'
> = {
  [RESOURCE_PLATFORM.WEB]: 'web',
  [RESOURCE_PLATFORM.APP]: 'app',
  [RESOURCE_PLATFORM.DASHBOARD]: 'dashboard',
  [RESOURCE_PLATFORM.SYSTEM]: 'system',
};

export enum RESOURCE_PERMISSION {
  CREATE = 'Create',
  READ = 'Read',
  UPDATE = 'Update',
  DELETE = 'Delete',
}

export const RESOURCE_PERMISSION_OPTIONS = [
  { label: 'Create', value: RESOURCE_PERMISSION.CREATE },
  { label: 'Read', value: RESOURCE_PERMISSION.READ },
  { label: 'Update', value: RESOURCE_PERMISSION.UPDATE },
  { label: 'Delete', value: RESOURCE_PERMISSION.DELETE },
];
